const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirectionsRafiki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.79,81.62a61.77,61.77,0,0,1,23.42-11.37c21.18-5,44.42,2.62,60.72,16.31,14.3,12,24.86,29.82,31.07,47.67,5.48,15.77,6.72,35.46,20.11,47.08,9.43,8.17,23.48,9.79,35.3,5.75s21.44-13.08,28.1-23.63C312.15,145,316,121.29,332.3,106.79a46.91,46.91,0,0,1,48.54-7.92c45.79,19.61,27.34,88.34,12,122.37-11.51,25.54-29.64,48.34-53.05,63.73-37.16,24.42-84.73,28.49-128.56,21C178,300.32,145,288,120,265.38c-22.14-20-37.1-47.2-44.75-76-6.16-23.24-7.66-48.37.25-71.08A80.54,80.54,0,0,1,101.79,81.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.79,81.62a61.77,61.77,0,0,1,23.42-11.37c21.18-5,44.42,2.62,60.72,16.31,14.3,12,24.86,29.82,31.07,47.67,5.48,15.77,6.72,35.46,20.11,47.08,9.43,8.17,23.48,9.79,35.3,5.75s21.44-13.08,28.1-23.63C312.15,145,316,121.29,332.3,106.79a46.91,46.91,0,0,1,48.54-7.92c45.79,19.61,27.34,88.34,12,122.37-11.51,25.54-29.64,48.34-53.05,63.73-37.16,24.42-84.73,28.49-128.56,21C178,300.32,145,288,120,265.38c-22.14-20-37.1-47.2-44.75-76-6.16-23.24-7.66-48.37.25-71.08A80.54,80.54,0,0,1,101.79,81.62Z",
    style: {
      fill: "#fff",
      opacity: 0.9,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-45"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-45",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sidewalk--inject-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423,366.76s4.69-15.73-4.81-18.87S403,337.4,403.35,329.08s-9.69-16.42-17.19-8.62-6.5-6-16.5-9.35-18.47,4.78-15.73,12.21S346.8,335.4,335,329.08s-24.82,5.18-22.32,14.18.46,10-7,7-20.85,5.5-16.16,16.5S423,366.76,423,366.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,366.76s4.69-15.73-4.81-18.87S403,337.4,403.35,329.08s-9.69-16.42-17.19-8.62-6.5-6-16.5-9.35-18.47,4.78-15.73,12.21S346.8,335.4,335,329.08s-24.82,5.18-22.32,14.18.46,10-7,7-20.85,5.5-16.16,16.5S423,366.76,423,366.76Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.66,368.26c5-5,.5-13.5-4.5-14.5s-10-9.8-10.26-15.4-9.24-22.83-23.24-12.19-9.74,1.57-19.87-1.42-16.51,5.61-12.07,12.06c0,0-10.17-2.55-14.36,6.95s0,15.4,0,15.4-19.14-.57-17.42,11.27S171.66,368.26,171.66,368.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.66,368.26c5-5,.5-13.5-4.5-14.5s-10-9.8-10.26-15.4-9.24-22.83-23.24-12.19-9.74,1.57-19.87-1.42-16.51,5.61-12.07,12.06c0,0-10.17-2.55-14.36,6.95s0,15.4,0,15.4-19.14-.57-17.42,11.27S171.66,368.26,171.66,368.26Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.16,368.56v13.7h-386v-13.7a4.08,4.08,0,0,1,4-4.3H436.12A4.08,4.08,0,0,1,440.16,368.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 364.26,
    width: 24,
    height: 18,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.16,
    y: 364.26,
    width: 23,
    height: 18,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.16,
    y: 364.26,
    width: 24,
    height: 18,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.16,
    y: 364.26,
    width: 23,
    height: 18,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.16,
    y: 364.26,
    width: 23,
    height: 18,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.16,
    y: 364.26,
    width: 24,
    height: 18,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.16,
    y: 364.26,
    width: 23,
    height: 18,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.16,
    y: 364.26,
    width: 24,
    height: 18,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.16,
    y: 364.26,
    width: 24,
    height: 18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.16,
    y: 364.26,
    width: 23,
    height: 18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.16,
    y: 364.26,
    width: 24,
    height: 18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.16,
    y: 364.26,
    width: 23,
    height: 18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.16,
    y: 364.26,
    width: 23,
    height: 18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.16,
    y: 364.26,
    width: 24,
    height: 18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.16,
    y: 364.26,
    width: 23,
    height: 18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.16,
    y: 364.26,
    width: 24,
    height: 18,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.16,368.56v13.7h-386v-13.7a4.08,4.08,0,0,1,4-4.3H436.12A4.08,4.08,0,0,1,440.16,368.56Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Map--inject-45"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "198.39 359.61 198.39 151.56 268.02 143.17 298.62 149 308.62 150.9 330.09 154.99 344.4 152.17 354.4 150.2 401.5 140.93 401.5 348.98 354.4 358.26 344.4 360.23 330.09 363.05 268.02 351.23 263.98 351.72 251.93 353.17 198.39 359.61",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.39 359.61 198.39 151.56 268.02 143.17 298.62 149 308.62 150.9 330.09 154.99 344.4 152.17 354.4 150.2 401.5 140.93 401.5 348.98 354.4 358.26 344.4 360.23 330.09 363.05 268.02 351.23 263.98 351.72 251.93 353.17 198.39 359.61",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.4,257.46V242a2.46,2.46,0,0,0-2.93-2.42L198.39,267.09V256.9L255.16,246a2.47,2.47,0,0,0,1.91-3.08l-10.91-39.69a2.45,2.45,0,0,0-2.84-1.76l-44.93,8.66V199.93l52.12-10.05a2.47,2.47,0,0,1,2.84,1.77L267,241.39a2.47,2.47,0,0,0,2.84,1.77L296.62,238a2.46,2.46,0,0,0,2-2.42V177.16a2.46,2.46,0,0,0-2-2.42l-32.22-5.94a2.57,2.57,0,0,0-.83,0L198.39,179V168.92l65.29-10.27a2.31,2.31,0,0,1,.83,0l31.2,5.74a2.46,2.46,0,0,0,2.91-2.42V149l10,1.9v81.81a2.48,2.48,0,0,0,2.94,2.43l30.84-5.94a2.45,2.45,0,0,0,2-2.42V152.17l10-2v73.71a2.47,2.47,0,0,0,2.94,2.42l20.79-4a2.46,2.46,0,0,0,2-2.42v-51a2.45,2.45,0,0,1,2-2.41l19.4-4v10.21l-9.4,1.94a2.47,2.47,0,0,0-2,2.42v40a2.46,2.46,0,0,0,2.93,2.42l8.44-1.62V228l-45.1,8.67a2.48,2.48,0,0,0-2,2.43v69.76a2.47,2.47,0,0,0,2.88,2.43L401.5,304V314.1l-45,7.48A2.48,2.48,0,0,0,354.4,324v34.24l-10,2V272.61a2.46,2.46,0,0,0-2.88-2.43l-37.09,6.39a2.48,2.48,0,0,0-1.77,1.29L264,351.72l-12.05,1.45,14.78-28.23a2.47,2.47,0,0,0-2.56-3.58l-65.76,10V321.26l75.1-11.43a2.48,2.48,0,0,0,1.82-1.3l20.79-39.69a2.45,2.45,0,0,1,1.76-1.28l44.5-7.67A2.47,2.47,0,0,0,344.4,257.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.07,358,269,346.32l-.76-.15-.78.1-4,.49-12,1.45L203.39,354V156l64.45-7.76,29.84,5.68,10,1.9,21.47,4.09,1,.18.95-.18,14.31-2.82,10-2L396.5,147V344.87l-43.07,8.49-10,2L330.07,358m0,5.09,14.31-2.82,10-2L401.5,349v-208l-47.1,9.27-10,2L330.09,155l-21.47-4.09-10-1.9L268,143.17l-69.63,8.39V359.61l53.54-6.44L264,351.72l4-.49,62.07,11.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.07,358,269,346.32l-.76-.15-.78.1-4,.49-12,1.45L203.39,354V156l64.45-7.76,29.84,5.68,10,1.9,21.47,4.09,1,.18.95-.18,14.31-2.82,10-2L396.5,147V344.87l-43.07,8.49-10,2L330.07,358m0,5.09,14.31-2.82,10-2L401.5,349v-208l-47.1,9.27-10,2L330.09,155l-21.47-4.09-10-1.9L268,143.17l-69.63,8.39V359.61l53.54-6.44L264,351.72l4-.49,62.07,11.82Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.09 363.05 330.09 154.99 268.02 143.17 268.02 351.23 330.09 363.05",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.42,227.15a1,1,0,0,1,.18,2l-26.2,4.7v29.9a1,1,0,0,1-.83,1l-49,8.45L276.42,319a1,1,0,1,1-1.77-.93l24.41-46.29a1,1,0,0,1,.71-.52l48.63-8.4V233a1,1,0,0,1,.82-1l27-4.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.65,318.57a1.89,1.89,0,1,1,1.88,1.88A1.89,1.89,0,0,1,273.65,318.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.54,228.15a1.89,1.89,0,1,1,1.88,1.88A1.88,1.88,0,0,1,374.54,228.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M276.51,289.08h0a11.27,11.27,0,0,0-15.95,0h0a11.27,11.27,0,0,0,0,15.94l8,8,8-8A11.27,11.27,0,0,0,276.51,289.08Zm-11.22,11.21a4.59,4.59,0,1,1,6.49,0A4.58,4.58,0,0,1,265.29,300.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.51,289.08a11.24,11.24,0,0,0-8.05-3.3v6.69a4.58,4.58,0,1,1,0,9.15v11.3l.07.07,8-8A11.27,11.27,0,0,0,276.51,289.08Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.39,196.78h0a11.27,11.27,0,0,0-15.94,0h0a11.29,11.29,0,0,0,0,15.95l8,8,8-8A11.27,11.27,0,0,0,384.39,196.78ZM373.18,208a4.59,4.59,0,1,1,6.48,0A4.59,4.59,0,0,1,373.18,208Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.39,196.78a11.25,11.25,0,0,0-8-3.29v6.69a4.58,4.58,0,1,1,0,9.15v11.3l.07.07,8-8A11.27,11.27,0,0,0,384.39,196.78Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-45"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "92.03 394.99 97.57 400.58 110.96 388.23 105.42 382.63 92.03 394.99",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,400.71l-6.72-6.78a.7.7,0,0,0-.86-.1l-6.06,3.82a1.17,1.17,0,0,0-.35,1.61,1.56,1.56,0,0,0,.16.2c2.21,2.16,3.93,3.62,6.66,6.38,1.68,1.7,6.58,7,8.9,9.34s4.94.36,4.21-.81c-3.33-5.24-5.24-9.77-5.37-12.37A1.9,1.9,0,0,0,99,400.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.42 382.64 110.95 388.23 104.04 394.6 98.51 389.01 105.42 382.64",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.59,401.86a.18.18,0,0,1,0-.21.16.16,0,0,1,.19-.06c.33.07,3.22.78,3.51,1.71a.54.54,0,0,1-.14.59,1.07,1.07,0,0,1-1,.43,2.31,2.31,0,0,1-1.35-.79A9.16,9.16,0,0,1,98.59,401.86Zm.56.2a3.8,3.8,0,0,0,2.07,1.89.74.74,0,0,0,.65-.29c.1-.11.11-.21.07-.24a.46.46,0,0,0-.13-.21A7.6,7.6,0,0,0,99.15,402.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.52,401.85a.21.21,0,0,1,.06-.18c.08-.07,1.82-1.53,3-1.4a1,1,0,0,1,.73.39.62.62,0,0,1,.07.77c-.48.7-2.81.8-3.69.54l-.07-.07A.14.14,0,0,1,98.52,401.85Zm3.06-1.25a4.32,4.32,0,0,0-2.4,1.07c1,.14,2.64-.07,2.93-.5,0,0,.11-.15-.06-.32l-.06-.07A.62.62,0,0,0,101.58,400.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.63,195.21s12.49,20,14.86,22.51,18-23.65,19.22-27.14,16.85-3.59,17.92-3.14.35,8-2.65,9.55-13.31,1.15-13.31,1.15-9.08,29.25-19.76,30.74-22.32-24.95-22.32-24.95Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.47,185.27c7.84,1.4,18.12,22.57,18.12,22.57l-9.06,11.86L171.26,209Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.59,207.84l-9.06,11.86-.3-.29-11-10.39.14-1.52,2.07-22.23C181.31,186.67,191.59,207.84,191.59,207.84Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.23,219.41l-11-10.39.14-1.52,3.81-7.71S182.18,206.57,182.23,219.41Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.26,254.48S152.71,323.75,140,351s-30.61,41.54-30.61,41.54l-8.29-10.22s23.3-33.14,28.35-53.59S136.19,266,136.19,266Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.26,254.48S152.71,323.75,140,351s-30.61,41.54-30.61,41.54l-8.29-10.22s23.3-33.14,28.35-53.59S136.19,266,136.19,266Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.73 410.37 184.19 407.88 179.04 390.4 171.57 392.89 176.73 410.37",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.93,406.67l-9.06,3a.7.7,0,0,0-.46.73l.75,7.13a1.16,1.16,0,0,0,1.28,1,1.14,1.14,0,0,0,.25-.06c2.91-1,5-1.92,8.67-3.15,2.27-.75,9.18-2.8,12.31-3.84s2.51-4.28,1.14-4.13c-6.17.66-11.08.37-13.47-.67A1.91,1.91,0,0,0,184.93,406.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.58 392.9 179.04 390.41 181.69 399.42 174.23 401.91 171.58 392.9",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.79,407.53a.17.17,0,0,1-.18-.11.16.16,0,0,1,0-.2c.2-.26,2.12-2.54,3.09-2.39a.57.57,0,0,1,.47.39,1.15,1.15,0,0,1-.06,1.08,2.3,2.3,0,0,1-1.3.85A9.62,9.62,0,0,1,185.79,407.53Zm.43-.42a3.78,3.78,0,0,0,2.61-1,.75.75,0,0,0,0-.71c-.06-.14-.14-.19-.19-.17a.34.34,0,0,0-.24,0A7.64,7.64,0,0,0,186.22,407.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.76,407.58a.17.17,0,0,1-.14-.13c0-.11-.56-2.31.06-3.3a1,1,0,0,1,.68-.48.6.6,0,0,1,.72.28c.42.73-.52,2.87-1.15,3.55l-.09,0A.16.16,0,0,1,185.76,407.58Zm.22-3.3a4.46,4.46,0,0,0-.1,2.63c.57-.83,1.11-2.39.85-2.85,0,0-.09-.17-.31-.09l-.09,0A.65.65,0,0,0,186,404.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.46,249.93a83.79,83.79,0,0,0,.81,39.4c4.31,15.48,41.12,109.16,41.12,109.16l12.8-3.68L157.12,283.35s10.12-14.33,14.14-28.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.28 396.3 170.19 401.67 166.18 396.15 185.18 390.97 186.28 396.3",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.28 396.3 170.19 401.67 166.18 396.15 185.18 390.97 186.28 396.3",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.87 397.33 96.94 385.28 100.11 379.24 113.16 393.98 108.87 397.33",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.87 397.33 96.94 385.28 100.11 379.24 113.16 393.98 108.87 397.33",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.39,181.67a176.93,176.93,0,0,1,.35,26.35c-.34,6.13-.94,11.92-1.6,17.17-1.54,12.28-7.81,35.06-7.81,35.06l32.31,8.5,2.93-14.27,3,14.27L170,264.8c10-31.73,10.26-63.74,9-72.94a8,8,0,0,0-5.56-6.59c-1.47-.46-3.18-1-5-1.4-.71-.13-1.4-.32-2.12-.46a153.64,153.64,0,0,0-17.78-1.94c-1.12-.07-2.27-.1-3.39-.12A103.26,103.26,0,0,0,134.39,181.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,264.8l-6.41,3.95-3-14.27-2.93,14.27-32.31-8.5s6.27-22.78,7.81-35.06c.16-1.25.31-2.53.46-3.84.47-4.19.88-8.66,1.14-13.33.16-2.56.26-5.13.3-7.69a176,176,0,0,0-.65-18.66,103.26,103.26,0,0,1,10.8-.32c1.12,0,2.27.05,3.39.12a153.64,153.64,0,0,1,17.78,1.94c.72.14,1.41.33,2.12.46,1.81.44,3.52.94,5,1.4a8,8,0,0,1,5.56,6.59C180.25,201.06,180,233.07,170,264.8Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.52,161.59c.5,5.85.48,16.45-3.94,19.83a17.9,17.9,0,0,0,13.11,6.94c4.93.43,5.56-3,4.67-5-6.22-2.22-5.54-6.93-3.94-11.26Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,165.89l5.85,6.2a19.6,19.6,0,0,0-.89,3.1c-2.4-.61-5.44-3.65-5.43-6.23A8.22,8.22,0,0,1,156.56,165.89Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.77,152.92c-.38,7.79-1,12.33,2.51,16.71,5.24,6.62,15.18,4.11,17.89-3.42,2.42-6.78,2.61-18.39-4.64-22.29a10.65,10.65,0,0,0-15.76,9Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.28,156.36c-.11.62.21,1.18.63,1.22s.8-.43.87-1.06-.21-1.18-.62-1.22S164.36,155.73,164.28,156.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.41,157.14c-.11.62.22,1.17.62,1.22s.8-.44.88-1.07-.22-1.17-.63-1.22S171.48,156.54,171.41,157.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.11,157.2a22.54,22.54,0,0,0,2.43,5.72,3.68,3.68,0,0,1-3.09.24Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.32,153.82a.41.41,0,0,0,.38-.11,3,3,0,0,1,2.5-1,.37.37,0,0,0,.43-.3.36.36,0,0,0-.3-.43h0a3.68,3.68,0,0,0-3.17,1.2.37.37,0,0,0,0,.52h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.19,165.71h0a5.7,5.7,0,0,1-4.11-3.3.21.21,0,0,1,.12-.25.19.19,0,0,1,.25.1v0a5.47,5.47,0,0,0,3.83,3,.19.19,0,0,1,.16.22v0a.19.19,0,0,1-.22.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.74,155a.33.33,0,0,0,.22,0,.38.38,0,0,0,.23-.47h0a3.7,3.7,0,0,0-2.44-2.37.38.38,0,0,0-.44.28h0a.39.39,0,0,0,.27.45h0a3,3,0,0,1,1.91,1.9A.35.35,0,0,0,174.74,155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.09,159.51s4.93-6.37,3.67-12.24a11.21,11.21,0,0,1,7.67,1.79,11.39,11.39,0,0,0-.17-2.71s7,.49,10.41,4.93a11.85,11.85,0,0,0-2.53-7.13,5.32,5.32,0,0,1,3.06.36s-5.59-5.89-15.82-4.34-14.11,7.11-13,16.19S152.91,168,152.91,168s-1.07-6.94-.43-8.38S154.09,159.51,154.09,159.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.35,161.08a7.42,7.42,0,0,0,4.24,3.75c2.46.83,3.83-1.35,3.27-3.74-.53-2.13-2.42-5.19-5-5S147.32,158.9,148.35,161.08Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.54,140.33a41.88,41.88,0,0,0-7.12,1.82,31.74,31.74,0,0,0-4.8,2.15h0c-7.53,4.15-9.45,9.51-9.45,9.51s-.24-.68-.56-1.74-.75-2.44-1.14-3.88h0c-.75-2.7-1.37-5.52-1-6.33,3.21-7.23,13.39-9.26,14.76-8.86.83.25,4,2.83,6.43,4.86,1.23,1,2.26,1.9,2.69,2.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.32,140.14a29.6,29.6,0,0,0-6.9,2c-1.4.56-3,1.27-4.8,2.15h0c-5.71,2.78-8.58,5.57-10,7.77-.33-1.05-.75-2.44-1.14-3.88h0c2.81-2.82,10.33-9.38,20.18-10.33C166.86,138.87,167.89,139.76,168.32,140.14Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.35,156.36s-6.86,4.81-7.29,2.25c-1.11-6.57,17.09-21,34.85-20.66,14.59.27-1.1,4.73-1.1,4.73C168,140.67,146.89,149.85,147.35,156.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.35,156.36s-6.86,4.81-7.29,2.25c-1.11-6.57,17.09-21,34.85-20.66,14.59.27-1.1,4.73-1.1,4.73C168,140.67,146.89,149.85,147.35,156.36Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.46,177.57s3.44,3.58,11.61,7.43c0,0,1.94-1.49,2.19-6l5.22,4.91-1.16,8.23-3.47-3.83-1.8,23.92s1.13-16-2.8-23.15l-2.63,4.06s-9.5-3.29-12.28-11.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.48,183.87l-1.16,8.23-3.47-3.83-1.8,23.92s1.13-16-2.8-23.15l-2.63,4.06s-9.5-3.29-12.28-11.78l5.12-3.75s3.44,3.58,11.61,7.43l0,0c.22-.18,1.94-1.75,2.17-6Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.41,197.45c-.29-6-1.34-12.45-1.34-12.45l0,0c.22-.18,1.94-1.75,2.17-6a6,6,0,0,1-.59,5.2Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,266.25a10.82,10.82,0,0,1,1.32,5.15c.13,3.29-.54,9.74-1.32,10.55-.46.47-8.15-1.69-8.9-3.6-.34-.87,1-9.72,2.57-12.1S119,266.25,119,266.25Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.09,202.59s-3.62,14-10.49,18.76c.47-4.19.88-8.66,1.14-13.33.16-2.56.26-5.13.3-7.69Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.33,199.79s-9.29,16.35-11,21.89-1.68,44.57-1.68,44.57H119s4-38.77,6.33-43.78,10.86-16.56,10.86-16.56Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,181.57c-4.25-.68-15.66,24.24-15.66,24.24l12,7.53s7.84-7.3,11.73-10.75S142.9,182.68,136,181.57Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,181.57c-4.25-.68-15.66,24.24-15.66,24.24l12,7.53s7.84-7.3,11.73-10.75S142.9,182.68,136,181.57Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.32 204.08 134.38 213.34 131.26 216.14 118.8 208.03 120.32 204.08",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.32 204.08 134.38 213.34 131.26 216.14 118.8 208.03 120.32 204.08",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.17 218.85 190.91 205.89 193.36 209.29 183.94 220.79 180.17 218.85",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.17 218.85 190.91 205.89 193.36 209.29 183.94 220.79 180.17 218.85",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.28,188.15l10.6-14.7a.64.64,0,0,1,.62-.25l6.92,1.22a.63.63,0,0,1,.4,1L229,190.14a.62.62,0,0,1-.62.24l-6.68-1.25A.63.63,0,0,1,221.28,188.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,187.73l10.6-14.7a.62.62,0,0,1,.62-.25l6.92,1.21a.63.63,0,0,1,.4,1l-10.84,14.74a.63.63,0,0,1-.62.24l-6.68-1.25A.63.63,0,0,1,220.52,187.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.55 173.52 238.18 174.7 227.59 188.94 221.16 187.76 231.55 173.52",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.65,117.75a26.9,26.9,0,1,0-30.4,26.66l1.3,14.13,2.48-13.9A26.9,26.9,0,0,0,259.65,117.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.65,117.75a26.9,26.9,0,1,0-30.4,26.66l1.3,14.13,2.48-13.9A26.9,26.9,0,0,0,259.65,117.75Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.87 117.75 219.63 106.78 223.93 117.75 219.63 128.71 245.87 117.75",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.93 117.75 245.87 117.75 219.63 128.71 223.93 117.75",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionsRafiki);
export default __webpack_public_path__ + "static/media/Directions-rafiki.a68bd560771d77ce6ca3a69a594f684c.svg";
export { ForwardRef as ReactComponent };